import { render, staticRenderFns } from "./EndpointsUnHealthy.vue?vue&type=template&id=67798f74&scoped=true&"
var script = {}
import style0 from "./EndpointsUnHealthy.vue?vue&type=style&index=0&id=67798f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67798f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67798f74')) {
      api.createRecord('67798f74', component.options)
    } else {
      api.reload('67798f74', component.options)
    }
    module.hot.accept("./EndpointsUnHealthy.vue?vue&type=template&id=67798f74&scoped=true&", function () {
      api.rerender('67798f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/EndpointsUnHealthy.vue"
export default component.exports